import UsualDialog from './UsualDialog/index.vue'
import ConTop from './ConTop/index.vue'
import UsualTable from './UsualTable/index.vue'
import ComAvatar from './ComAvatar/index.vue'

interface IState {
  UsualDialog: String,
  ConTop:String,
  UsualTable: String,
  ComAvatar:String
}

const components: { [IState: string]: any } = {
  UsualDialog,
  ConTop,
  UsualTable,
  ComAvatar
}

export default {
  install: (app: { component: (key: string, components: any) => void }) => {
    for (const key in components) {
      app.component(key, components[key])
    }
  }
}
